import { Quill } from 'vue-quill-editor';
// 源码中是import直接倒入，这里要用Quill.import引入
const BlockEmbed = Quill.import('blots/block/embed');
const Link = Quill.import('formats/link');

const ATTRIBUTES = ['height', 'width'];

class Audio extends BlockEmbed {
  static create(value) {
    const node = super.create(value);
    // console.log(value.split('.').pop(), 'audio===========================');
    // 添加Audio标签所需的属性
    node.setAttribute('controlslist', 'nodownload');
    node.setAttribute('controls', 'controls');
    node.setAttribute('type', 'audio/mp3');
    node.setAttribute('src', this.sanitize(value));
    return node;
  }

  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  static sanitize(url) {
    return Link.sanitize(url); // eslint-disable-line import/no-named-as-default-member
  }

  static value(domNode) {
    return domNode.getAttribute('src');
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  html() {
    const { audio } = this.value();
    return `<a href="${audio}">${audio}</a>`;
  }
}
Audio.blotName = 'audio'; // 这里不用改，楼主不用iframe，直接替换掉原来，如果需要也可以保留原来的，这里用个新的blot
Audio.className = 'ql-audio';
Audio.tagName = 'audio'; // 用video标签替换iframe

export default Audio;



// WEBPACK FOOTER //
// ./src/util/quill/audio.js